import { Tooltip } from 'primereact/tooltip';
import classes from './header.module.scss';
import { drugTabInterface } from 'Interfaces/FactsInterfaces/drugInterfaces';

const ConceptTabHeader = ({
  drugDetails,
  isSelected,
  tabIndex,
}: {
  drugDetails: drugTabInterface;
  isSelected: boolean;
  tabIndex: number;
}) => {
  return (
    <div
      className={
        isSelected ? classes.conceptsContainerSelected : classes.conceptsContainerUnselected
      }
    >
      <Tooltip position="top" target={`.tab-${tabIndex}`} content={drugDetails.Strength} />
      <div
        style={{ fontSize: '1rem', padding: '0.5rem', fontWeight: '400' }}
        className={`tab-${tabIndex}`}
      >
        {drugDetails.Strength}
      </div>
    </div>
  );
};

export default ConceptTabHeader;
